module.exports = __webpack_public_path__ + "static/media/tech-writing.82fed3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/tech-writing.png
// module id = 619
// module chunks = 157